import { AdminApp } from '@acorns/admin-framework-binding'
import { createContext, useContext } from 'react'

interface IAppsContext {
  apps: AdminApp[] | null
  appPaths: string[] | null
  loading: boolean
}

export const AppsContext = createContext<IAppsContext>({
  apps: null,
  appPaths: null,
  loading: false,
})

export const useAppsContext = () => useContext(AppsContext)
